import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core'
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgxMaskModule, IConfig } from 'ngx-mask';

import { RoutingModule } from './routing.module';
import { FormResourceModule } from '../forms';


import {
    ForgotPasswordDialog,
    LandingComponent,
    LoginDialog,
    RegistrationDialog,
} from './components';

import {
    RegistrationService
} from './services';

import { AestheticsModule } from '@smartsoftware/reflex-core';


@NgModule({
    imports: [
        CommonModule,
        RoutingModule,
        FormsModule,
        ReactiveFormsModule,

        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatRippleModule,
        MatIconModule,
        MatCheckboxModule,
        NgxMaskModule,

        FormResourceModule,

        AestheticsModule
    ],
    exports: [],
    declarations: [
        ForgotPasswordDialog,
        LandingComponent,
        LoginDialog,
        RegistrationDialog
    ],
    entryComponents: [],
    providers: [
        RegistrationService
    ]
})
export class LandingModule {}
